import { isDevelopment, logger } from './logger'

class CacheStats {
  constructor() {
    this.reset()
  }

  hits = { memory: 0, storage: 0 }
  misses = 0
  errors = 0
  storageFailures = 0
  totalRequests = 0
  avgResponseTime = 0
  totalResponseTime = 0

  recordHit(type) {
    if (!isDevelopment) return
    this.hits[type]++
    this.totalRequests++
    this.logStats()
  }

  recordMiss() {
    if (!isDevelopment) return
    this.misses++
    this.totalRequests++
    this.logStats()
  }

  recordError() {
    if (!isDevelopment) return
    this.errors++
    this.logStats()
  }

  recordStorageFailure() {
    if (!isDevelopment) return
    this.storageFailures++
    this.logStats()
  }

  recordResponseTime(time) {
    if (!isDevelopment) return
    this.totalResponseTime += time
    this.avgResponseTime = this.totalResponseTime / this.totalRequests
  }

  logStats() {
    if (!isDevelopment) return

    const hitRate = (((this.hits.memory + this.hits.storage) / this.totalRequests) * 100).toFixed(2)
    const memoryHitRate = ((this.hits.memory / this.totalRequests) * 100).toFixed(2)
    const storageHitRate = ((this.hits.storage / this.totalRequests) * 100).toFixed(2)

    logger.debug(
      '[LottieCache] 캐시 통계:\n',
      `총 요청: ${this.totalRequests}\n`,
      `캐시 적중률: ${hitRate}%\n`,
      `- 메모리 캐시: ${memoryHitRate}% (${this.hits.memory}회)\n`,
      `- 스토리지 캐시: ${storageHitRate}% (${this.hits.storage}회)\n`,
      `캐시 미스: ${this.misses}회\n`,
      `에러: ${this.errors}회\n`,
      `스토리지 실패: ${this.storageFailures}회\n`,
      `평균 응답시간: ${this.avgResponseTime.toFixed(2)}ms`
    )
  }

  reset() {
    if (!isDevelopment) return
    this.hits = { memory: 0, storage: 0 }
    this.misses = 0
    this.errors = 0
    this.storageFailures = 0
    this.totalRequests = 0
    this.avgResponseTime = 0
    this.totalResponseTime = 0
  }
}

export const cacheStats = new CacheStats()
